import { useEffect, useRef } from 'react'
import Phaser from 'phaser'
import { useGameStore } from '../stores/gameStore'
import { BootScene } from '../scenes/BootScene'
import { GameScene } from '../scenes/GameScene'
import HUD from './HUD'
import PuzzlePanel from './PuzzlePanel'

export default function Game() {
  const gameRef = useRef<Phaser.Game | null>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const { leaveRoom, activePuzzle, closePuzzle, requestPuzzle, phase } = useGameStore()

  useEffect(() => {
    if (!containerRef.current || gameRef.current) return

    const config: Phaser.Types.Core.GameConfig = {
      type: Phaser.AUTO,
      parent: containerRef.current,
      width: window.innerWidth,
      height: window.innerHeight,
      backgroundColor: '#0A2E36',
      physics: {
        default: 'arcade',
        arcade: {
          gravity: { x: 0, y: 0 },
          debug: false,
        },
      },
      scene: [BootScene, GameScene],
      scale: {
        mode: Phaser.Scale.RESIZE,
        autoCenter: Phaser.Scale.CENTER_BOTH,
      },
    }

    gameRef.current = new Phaser.Game(config)

    // Cleanup
    return () => {
      if (gameRef.current) {
        gameRef.current.destroy(true)
        gameRef.current = null
      }
    }
  }, [])

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      if (gameRef.current) {
        gameRef.current.scale.resize(window.innerWidth, window.innerHeight)
      }
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div className="w-full h-full relative">
      {/* Phaser canvas container */}
      <div ref={containerRef} className="absolute inset-0" />

      {/* React HUD overlay */}
      <HUD />

      {/* Puzzle trigger button (for testing) */}
      {phase === 'explore' && !activePuzzle && (
        <button
          onClick={() => requestPuzzle('easy')}
          className="absolute bottom-4 left-1/2 -translate-x-1/2 px-6 py-3 bg-emerald-neon text-gray-900
                     font-bold rounded-lg hover:bg-emerald-400 transition-colors z-50"
        >
          Rozpocznij zagadke (Test)
        </button>
      )}

      {/* Puzzle panel */}
      {activePuzzle && (
        <PuzzlePanel puzzle={activePuzzle} onClose={closePuzzle} />
      )}

      {/* Exit button */}
      <button
        onClick={leaveRoom}
        className="absolute top-4 right-4 px-3 py-1 bg-gray-800/80 text-gray-400 rounded
                   hover:text-red-400 hover:bg-gray-800 transition-colors z-50"
      >
        Wyjdz
      </button>
    </div>
  )
}
